import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-639b7072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-oc-qrcode" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box-step" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "box-step" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { class: "box-step" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "subtitle" }

import { onMounted, ref } from 'vue';
  import { ColorVariants } from '@/constants';
  import CollectionTitle from './components/collection-title.vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { request } from '@/utils';
  import { IProgram } from '@/types/program';
  import { authStore } from '@/stores';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

  const program = ref<IProgram | null>(null);
  const route = useRoute();
  const programId = route.params.id;
  onMounted(async () => {
    authStore.tryFetchData();
    const { data } = await request.get<IProgram>(`/programs/${programId}`);
    program.value = data;
  });

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CollectionTitle, {
        title: program.value?.name || ''
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('offline_collection.step_index', { index: 1 })), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('step1')), 1),
        _createElementVNode("img", {
          src: _unref(authStore).user.qrcode?.url,
          class: "qrcode"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(t)('offline_collection.step_index', { index: 2 })), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('step2')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref(t)('offline_collection.step_index', { index: 3 })), 1),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('step3')), 1),
        _createVNode(_component_router_link, {
          to: { name: program.value?.participation_request_id ? 'oc_user_requests.detail' : 'home', params: { id: program.value?.participation_request_id } },
          class: "link"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_button, {
              class: "btn-done",
              pill: "",
              variant: _unref(ColorVariants).primary
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('offline_collection.done')), 1)
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})